import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
    apiGetTestCaseList,
    apiGetTestRunDetail,
    apiGetTestRunList,
    apiGetTestRunTestCaseDetail,
} from './testRun.service'

const initialState = {
    testRunListLoading: false,
    testRun: [],
    testCaseListLoading: false,
    testCase: [],
    testRunDetailLoading: false,
    testRunDetail: {},
    testRunTestCaseDetailLoading: false,
    testRunTestCaseDetail: {},
    pagination: {
        currentPage: 1,
        pageSize: 10,
    },
    defaultFilter: {
        epic: [],
        sprint: '',
        tags: [],
        status: '',
    },
    filter: {
        epic: [],
        sprint: '',
        tags: [],
        status: '',
    },
    searchValue: '',
    fetchReportToggle: false,
}

// LIST TEST RUN
export const testRunList = createAsyncThunk(
    'testRunListSlice/read',
    async (payload = {}) => {
        // const response = await getSprintsList(payload)
        const response = await apiGetTestRunList(payload)
        return response
    }
)

// LIST TEST CASE
export const testCaseList = createAsyncThunk(
    'testRunTestCaseListSlice/read',
    async (payload = {}) => {
        // const response = await getSprintsList(payload)
        const response = await apiGetTestCaseList(payload)
        return response
    }
)

//GET TEST RUN DETAIL
export const testRunDetail = createAsyncThunk(
    'testRunListSlice/details',
    async (payload = {}) => {
        // const response = await getSprintsList(payload)
        const response = await apiGetTestRunDetail(payload)
        return response
    }
)

//GET TEST RUN TEST CASE DETAIL
export const testRunTestCaseDetail = createAsyncThunk(
    'testRunTestCaseSlice/details',
    async (payload = {}) => {
        // const response = await getSprintsList(payload)
        const response = await apiGetTestRunTestCaseDetail(payload)
        return response
    }
)

export const testRunListSlice = createSlice({
    name: 'testRunListSlice',
    initialState,
    reducers: {
        setPagination: (state, action) => {
            state.pagination = action.payload
            // state.selectedSprint = undefined
            // state.selectedSprintData = undefined
        },
        setSearchValue: (state, action) => {
            state.searchValue = action.payload
        },
        setFilter: (state, action) => {
            state.filter = action.payload
        },
        toggleReportDetails: (state, action) => {
            state.fetchReportToggle = action.payload
        },
        searchSprints: (state, action) => {
            state.search = action.payload
        },
        setSprintTasks: (state, action) => {
            state.listTasks = action.payload
        },
        setSprints: (state, action) => {
            state.sprints = action.payload
        },
        setEpics: (state, action) => {
            state.epics = action.payload
        },
        clearSprints: (state) => {
            state.search = ''
            state.sprints = []
            state.selectedSprint = undefined
        },
        setPointerEvent: (state, action) => {
            state.pointerEvent = action.payload
        },
        changeEditInput: (state, action) => {
            state.editInput = {
                id: action.payload.id,
                open: action.payload.open,
            }
        },
        changeEditTaskInput: (state, action) => {
            state.editTaskInput = {
                id: action.payload.id,
                open: action.payload.open,
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(testRunList.pending, (state) => {
                state.testRunListLoading = true
            })
            .addCase(testRunList.fulfilled, (state, action) => {
                state.testRunListLoading = false
                state.testRun = action.payload.data
            })
            .addCase(testRunDetail.pending, (state) => {
                state.testRunDetailLoading = true
            })
            .addCase(testRunDetail.fulfilled, (state, action) => {
                state.testRunDetailLoading = false
                state.testRunDetail = action.payload.data
            })
            .addCase(testCaseList.pending, (state) => {
                state.testCaseListLoading = true
            })
            .addCase(testCaseList.fulfilled, (state, action) => {
                state.testCaseListLoading = false
                state.testCase = action.payload.data
            })
            .addCase(testRunTestCaseDetail.pending, (state) => {
                state.testRunTestCaseDetailLoading = true
            })
            .addCase(testRunTestCaseDetail.fulfilled, (state, action) => {
                state.testRunTestCaseDetailLoading = false
                state.testRunTestCaseDetail = action.payload.data
            })
    },
})

export default testRunListSlice.reducer

export const testRunState = (state) => {
    const { testRunListSlice } = state
    const {
        testRunListLoading,
        testRun,
        testRunDetailLoading,
        testRunDetail,
        testCaseListLoading,
        testCase,
        pagination,
        searchValue,
        filter,
        defaultFilter,
        testRunTestCaseDetail,
        testRunTestCaseDetailLoading,
        fetchReportToggle,
    } = testRunListSlice
    return {
        testRunListLoading,
        testRun,
        testRunDetailLoading,
        testRunDetail,
        testCaseListLoading,
        testCase,
        pagination,
        searchValue,
        filter,
        defaultFilter,
        testRunTestCaseDetailLoading,
        testRunTestCaseDetail,
        fetchReportToggle,
    }
}

export const {
    setSearchValue,
    setPagination,
    setFilter,
    toggleReportDetails,
    switchViewModal,
    searchSprints,
    setSprints,
    clearSprints,
    setEpics,
    changeEditInput,
    changeEditTaskInput,
    setPointerEvent,
    switchTab,
    sprintSelect,
    clearSprintSelect,
    setSprintTasks,
} = testRunListSlice.actions
